import type {
    ActionFlowNode,
    FlowNodeResultADT,
    WechatOpenChannelsActivityActionConfig,
    WechatOpenChannelsActivityActionConfigure
} from '@lighthouse/shared'
import { t } from 'i18next'

import type { ExecuteActionParams } from '../type'

export const handleOpenWechatChannelsActivityStream = async (
    node: ActionFlowNode<WechatOpenChannelsActivityActionConfigure>,
    params: ExecuteActionParams
): Promise<undefined | FlowNodeResultADT> => {
    throw new Error(t('cannotMiniProgramOpenChannelsActivity'))
}

export const handleOpenWechatChannelsActivity = (config: WechatOpenChannelsActivityActionConfig, params: ExecuteActionParams) => {
    throw new Error(t('cannotMiniProgramOpenChannelsActivity'))
}
